import React, { ReactNode } from 'react';

interface ServiceabilityHeaderProps {
  addEmptyRow: () => void;
  discardChanges: () => void;
  isEdited: boolean;
  children?: ReactNode;
}

export const ServiceabilityHeader: React.FC<ServiceabilityHeaderProps> = ({
  addEmptyRow,
  discardChanges,
  isEdited,
  children,
}) => {
  return (
    <div className="flex justify-between items-center mb-4">
      <h3 className="text-xl font-medium text-indigo-700">Serviceability</h3>
      <div className="flex items-center">
        {isEdited && <div className="mr-4">{children}</div>}
        <div className="space-x-2 flex items-center">
          <button
            onClick={addEmptyRow}
            className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700 transition-colors"
            title="Add a new serviceability entry to the table"
          >
            Add Entry
          </button>
          {isEdited && (
            <button
              onClick={discardChanges}
              className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 transition-colors"
              title="Revert all changes to the last saved state"
            >
              Discard Changes
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
